// extracted by mini-css-extract-plugin
export var card = "_60-0";
export var failedIcon = "_60-4";
export var failedIconBadge = "_60-3";
export var icon = "_60-1";
export var successIcon = "_60-2";